module.exports = __webpack_public_path__ + "static/media/EconSenso_Vlinder_Economie_web-12.a77e6996.jpg";